<template>
  <div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
          <div class="grid grid-cols-12 gap-x-2">
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2"
                  >Field</label
                >
                <select
                  id="tabulator-html-filter-field"
                  v-model="filter.field"
                  class="form-select"
                >
                <option value="first_name">No</option>
                <option value="first_name">First Name</option>
                <option value="last_name">Last Name</option>
                <option value="short_name">Short Name</option>
                <option value="email">Email</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2"
                >Type</label
              >
              <select
                id="tabulator-html-filter-type"
                v-model="filter.type"
                class="form-select w-fullo"
              >
                <option value="like" selected>like</option>
                <option value="=">=</option>
                <option value="<">&lt;</option>
                <option value="<=">&lt;=</option>
                <option value=">">></option>
                <option value=">=">>=</option>
                <option value="!=">!=</option>
              </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2">Value</label>
                <input
                  id="tabulator-html-filter-value"
                  v-model="filter.value"
                  type="text"
                  class="form-control sm:w-40"
                  placeholder="Search..."
                />
              </div>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button
                  id="tabulator-html-filter-go"
                  type="button"
                  class="btn btn-primary w-full"
                  @click="onFilter"
                >
                  Go
                </button>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button
                  id="tabulator-html-filter-reset"
                  type="button"
                  class="btn btn-secondary w-full"
                  @click="onResetFilter"
                >
                  Reset
                </button>
            </div>
          </div>
        </form>
        <div class="flex mt-5 sm:mt-0">
          <router-link
          :to="{ name: 'create-vendor-details' }"
          tag="button"
           class="btn btn-primary shadow-md mr-2">

         New Vendor
          </router-link>
          <div class="dropdown w-1/2 sm:w-auto">
            <button
              class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto"
              aria-expanded="false"
            >
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a
                  id="tabulator-export-csv"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportCsv"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <!-- <a
                  id="tabulator-export-json"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportJson"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a> -->
                <a
                  id="tabulator-export-xlsx"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportXlsx"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>

</template>

<script>
/* eslint-disable */
import { defineComponent, ref,onMounted, reactive,inject } from 'vue'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import { useRouter, useRoute } from 'vue-router'
import { BASE_URL } from '@/constants/config.js'
import { v_per_page_record } from '@/constants/config.js'
import { v_per_page_size } from '@/constants/config.js'
export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'first_name',
      type: 'like',
      value: ''
    })
  const swal = inject('$swal')
    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/master/get_vendor_details',
        ajaxConfig:{
            method:"GET", //set request type to Position
            headers: {
                "Content-type": 'application/json; charset=utf-8', //set specific content type
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: v_per_page_record,
        paginationSizeSelector: v_per_page_size,
        layout: 'fitColumns',
        headerSort: false,
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          // For HTML table
          {
            title: '#',
            responsive: 0,
            field: 'id',
            vertAlign: 'middle',
            print: false,
            download: false,
            width:50,
            minWidth: 50,
          },
          {
            title: 'Firm Name',
            responsive: 0,
            field: 'firm_name',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'First Name',
            responsive: 0,
            field: 'first_name',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Last Name',
            responsive: 0,
            field: 'last_name',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'User Name',
            responsive: 0,
            field: 'user_name',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Short Name',
            responsive: 0,
            field: 'short_name',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Email Id',
            responsive: 0,
            field: 'email',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Mobile No',
            responsive: 0,
            field: 'mobile_no',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Stone Type',
            responsive: 0,
            field: 'stone_name',
            vertAlign: 'middle',
            print: false,
            download: false,
          },
          {
            title: 'Status',
            field: 'active_status',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              // return `<div class="flex lg:justify-center ${
              //   cell.getData().active_status == 'Active' ? 'text-theme-9' : 'text-theme-6'
              //     }">
              //       <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${
              //         cell.getData().active_status == 'Active' ? 'Active' : 'Inactive'
              //       }
              //     </div>`
              const btn_status =cash(`<div class="flex lg:justify-center ${
                cell.getData().active_status == 'Active'
                  ? 'text-theme-9'
                  : 'text-theme-6'
              }">
                <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${
                  cell.getData().active_status == 'Active'
                    ? 'Active'
                    : 'Inactive'
                }
              </div>`)
              cash(btn_status).on('click', function() {   
                const params = { id: btoa(cell.getData().id),
                                u_id: btoa(cell.getData().user_id),
                                status:btoa(cell.getData().active_status),
                                u_type:btoa('VENDOR'),
                              } 
                var confirm_msg="";
                if(cell.getData().active_status=='Active')
                    confirm_msg="Do you want to inactive the vendor status?";
                else
                    confirm_msg="Do you want to active the vendor status?";
                swal.fire({
                        title: 'Are you sure?',
                        text: confirm_msg,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No'
                      }).then(result => {
                        if (result.isConfirmed || result.value) {
                          axios({
                            url: 'api/master/delete_vendor',
                            method: 'post',
                            baseURL: BASE_URL,
                            data: params,
                            headers: {
                              Authorization: 'Bearer ' + localStorage.getItem('token')
                            },
                            config: { headers: { Accept: 'application/json' } }
                          })
                            .then(res => {
                              swal.fire({
                                text: res.data.message,
                                icon: 'success',
                                buttonsStyling: false,
                                confirmButtonText: 'Ok, got it!',
                                heightAuto: false,
                                customClass: {
                                  confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
                                }
                              })
                              initTabulator()
                            })
                            .catch(error => {
                              // Handle error if needed
                            })
                        }
                      })
              })
              return btn_status[0] 
            }
          },
          {
            title: 'Edit',
            minWidth: 50,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const a = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>

              </div>`)
              cash(a).on('click', function() {
                //getDetails(cell.getData().id);
                router.push("/master/vendor/update/" + window.btoa(cell.getData().user_id));
              })

              return a[0]
            }
          },
          {
            title: 'Rates',
            minWidth: 50,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const a = cash(`<div class="btn btn-primary btn-sm py-2">Rates</div>`)
              cash(a).on('click', function() {
                //getDetails(cell.getData().id);
                router.push("/master/vendor/rates/" + window.btoa(cell.getData().user_id));
              })

              return a[0]
            }
          },
          {
            title: '#',
            responsive: 0,
            field: 'id',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'Firm Name',
            responsive: 0,
            field: 'firm_name',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'First Name',
            field: 'first_name',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'Last Name',
            field: 'last_name',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'User Name',
            field: 'user_name',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'Short Name',
            field: 'short_name',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'Email Id',
            field: 'email',
            visible: false,
            print: true,
            download: true,

          },
          {
            title: 'Mobile No',
            field: 'mobile_no',
            visible: false,
            print: true,
            download: true,
          },
          {
            title: 'Stone Type',
            field: 'stone_name',
            visible: false,
            print: true,
            download: true,
          },
          {
            title: 'Status',
            field: 'active_status',
            visible: false,
            print: true,
            download: true
          },
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      window.addEventListener('resize', () => {
        tabulator.value.redraw()
        feather.replace({
          'stroke-width': 1.5
        })
      })
    }

    // Filter function
    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    //Edit user
    const editUser = (id) => {
      // console.log(id);
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'first_name'
      filter.type = 'like'
      filter.value = ''
      onFilter()
    }


    // Export
    const onExportCsv = () => {
      tabulator.value.download('csv', 'Vendor_List.csv')
    }

    const onExportJson = () => {
      tabulator.value.download('json', 'data.json')
    }

    const onExportXlsx = () => {
      const win = window
      win.XLSX = xlsx
      tabulator.value.download('xlsx', 'Vendor_List.xlsx', {
        sheetName: 'Vendor'
      })
    }

    const onExportHtml = () => {
      tabulator.value.download('html', 'data.html', {
        style: true
      })
    }

    // Print
    const onPrint = () => {
      tabulator.value.print()
    }

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })


    return {
      tableRef,
      filter,
      onFilter,
      onResetFilter,
      onExportCsv,
      onExportJson,
      onExportXlsx,
      onExportHtml,
      onPrint,
      editUser
    }
  }
})
</script>
